import { ClientWebRouteParams } from '../model';
import { AppRouteConfig } from './model';
import { CITY_PATH_PARAMETER } from './const';

export const getRouterContextValue = ({
  routeConfig,
  routeMatchParams,
}: {
  routeConfig: AppRouteConfig;
  routeMatchParams: Record<string, string> | undefined;
}): ClientWebRouteParams => {
  return {
    pageId: routeConfig.pageId ?? null,
    pageProps: routeConfig.props ?? {},
    cityAlias: routeMatchParams?.[CITY_PATH_PARAMETER] ?? routeConfig.defaultCityAlias,
    hasCitySeparatedContent: routeConfig.hasCitySeparatedContent,
    routeId: routeConfig.routeId,
  };
};
